'use client'

import { CollectionListing } from '@/app/[locale]/collection/_components/collection-listing'
import { FilterGroupDesktop } from '@/app/[locale]/collection/_components/filter/filter-group/filter-group-desktop'
import { FilterSizeSection } from '@/app/[locale]/collection/_components/filter/filter-size-section'
import { FilterSummaryBar } from '@/app/[locale]/collection/_components/filter/filter-summary-bar'
import { Button } from '@/components/ui/button'
import { TCollectionData, TCollectionDetail } from '@/types/collection'
import { SlidersHorizontal } from 'lucide-react'
import { useTranslations } from 'next-intl'
import { useState } from 'react'

type Props = {
  collection: TCollectionDetail
  serverData: TCollectionData
  initialFilters?: Record<string, string | string[] | number | undefined>
  listingClassName?: string
  showTitle?: boolean
  topContent?: React.ReactNode
  hideSizeFilter?: boolean
}

export const FilterToggleDesktop = ({
  collection,
  serverData,
  initialFilters,
  listingClassName,
  showTitle,
  topContent,
  hideSizeFilter,
}: Props) => {
  const t = useTranslations()
  const [isFilterVisible, setIsFilterVisible] = useState(true)

  const toggleButton = (
    <Button
      variant='outline-neutral'
      size='small'
      className='font-medium normal-case'
      onClick={() => setIsFilterVisible((prev) => !prev)}
    >
      <SlidersHorizontal size={16} />
      {isFilterVisible ? t('button.hide_filters') : t('button.show_filters')}
    </Button>
  )

  return (
    <div className='flex flex-col gap-4'>
      {!hideSizeFilter && (
        <FilterSizeSection
          facets={collection.facets}
          card_facets={collection.card_facets}
        />
      )}

      {isFilterVisible && <div>{toggleButton}</div>}

      <div className='flex items-start gap-5'>
        {isFilterVisible && (
          <FilterGroupDesktop
            serverData={serverData}
            initialFilters={initialFilters}
          />
        )}
        <div className='flex flex-1 flex-col gap-6'>
          {topContent}
          <FilterSummaryBar
            showTitle={showTitle}
            collectionTitle={collection.title_display}
            facets={collection.facets}
            card_facets={collection.card_facets}
            serverData={serverData}
            initialFilters={initialFilters}
            startSlot={!isFilterVisible ? toggleButton : undefined}
          />
          <CollectionListing
            className={listingClassName ?? 'grid-cols-2 gap-y-4 md:gap-y-8 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-4'}
            serverData={serverData}
            initialFilters={initialFilters}
          />
        </div>
      </div>
    </div>
  )
}
